<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">

    </div>

    <div class="nav material2">
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/customers/details/{{user.id}}" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">access_alarm</mat-icon>
                <span>{{'Summary'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/customers/personal-data/{{user.id}}" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">access_alarm</mat-icon>
                <span>{{'Personal data'|translate}}</span>
            </a>
        </div>
        <div class="nav-item" *ngIf="user.cardsQuantity<1">
            <a class="nav-link" matRipple routerLink="/customers/cards/{{user.id}}/add" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">credit_card</mat-icon>
                <span>{{'Add card'|translate}}</span>
            </a>
        </div>

    </div>

</div>
<!-- / SIDEBAR CONTENT -->
